<template>
  <header class="fixed inset-x-0 top-0 z-30 flex items-center justify-between h-20 px-12 overflow-hidden font-bold bg-white shadow-md xl:px-16 bg-opacity-80">
    <router-link to="/">
      <app-logo />
    </router-link>

    <div class="space-x-2" @dblclick.prevent="quitApp">
      <span class="text-2xl">คอนโดใหม่</span>
      <span class="text-xl">เอสเซ็นท์ ระยอง 2</span>
    </div>
  </header>
</template>

<script>
import AppLogo from '@/components/AppLogo.vue'

export default {
  name: 'Header',
  components: {
    AppLogo,
  },
  methods: {
    quitApp () {
      window.close()
    },
  },
}
</script>

<style lang="postcss" scoped>
header {
  backdrop-filter: blur(8px);
};
</style>
